<template>
    <div class="p-6 h-full mb-4" v-if="Object.keys(qrcreate.fields)">
        <div class="w-52 text-center flex items-center justify-center flex-col h-full mx-auto"
            v-if="keys_fields.length == 0">
            <nuxt-img loading="lazy" src="/template.png" format="webp" width="120" />
            
            <button @click="SwitchTab()"
                class="h-10 w-full mt-4 flex items-center justify-center bg-success text-white  hover:drop-shadow-lg tex-white font-semibold  ">
                Choose a style
            </button>
        </div>

        <div class="mb-8" v-for="(param, i) in keys_fields">
            <fieldset class="border border-solid border-gray-300 px-3 rounded-md">
                <legend class="text-base font-semibold capitalize w-fit px-4">
                    {{ param }}
                </legend>
                <div class="w-full py-4 border-b border-gray-100"
                    v-for="(key_name, j) in Object.keys(qrcreate.fields[param])" :class="{
                        '!border-b-0': j == Object.keys(qrcreate.fields[param]).length - 1,
                    }">
                    <template v-if="qrcreate.fields[param][key_name].type == 'text'">
                        <div class="mb-2 flex items-center justify-between gap-1">
                            <div class="items-center flex">
                                <span class="text-xs mr-2">Font:</span>

                                <div @click="
                                    selectFont(
                                        param,
                                        key_name,
                                        qrcreate.fields[param][key_name].font_family
                                    )
                                " :style="{ fontFamily: qrcreate.fields[param][key_name].font_family }"
                                    class="text-xs cursor-pointer flex items-center font-semibold">
                                    {{ qrcreate.fields[param][key_name].font_family }}
                                    <ChevronDownIcon size="20" stroke-width="1" />
                                </div>
                            </div>
                            <div class="flex items-center">
                                <span class="text-xs mr-2">Spacing:</span>
                                <input type="number" class="bg-gray-200 w-24 px-2 h-8 rounded-md text-sm outline-none"
                                    v-model="qrcreate.fields[param][key_name].font_space" />
                            </div>
                        </div>
                        <input-style v-model:value="qrcreate.fields[param][key_name].value"
                            :label="qrcreate.fields[param][key_name].label" />
                        <input-style :type="'number'" v-model:value="qrcreate.fields[param][key_name].font_size"
                            :label="'Size (px)'" />
                    </template>
                    <template v-if="qrcreate.fields[param][key_name].type == 'color'">
                        <div class="flex flex-col w-full gap-2">
                            <div class="flex items-center justify-between ml-1">
                                <label class="text-sm">{{ qrcreate.fields[param][key_name].label }}</label>
                                <SwitchStyle v-model:value="qrcreate.fields[param][key_name].gradient" :label="'Gradient'"
                                    :size="'small'" />
                            </div>
                            <div class="mb-2 flex gap-2">

                                <div class="flex flex-wrap gap-3">
                                    <color-picker v-model:pureColor="qrcreate.fields[param][key_name].value"
                                        :format="'hex8'" :pickerType="'chrome'" :shape="'circle'" :isWidget="false" />
                                    <template v-if="qrcreate.fields[param][key_name].gradient">
                                        <ArrowRightIcon stroke-width="1" />
                                        <color-picker v-model:pureColor="qrcreate.fields[param][key_name].value_second"
                                            :format="'hex8'" :pickerType="'chrome'" :shape="'circle'" :isWidget="false" />
                                    </template>
                                </div>
                            </div>

                        </div>
                    </template>
                </div>
            </fieldset>
        </div>
        <list-fonts-modal ref="modal" :font_selected="font_selected" @changeFont="changeFont" />
    </div>
</template>
<script>
import { ChevronDownIcon, LetterAIcon, SeparatorIcon, ArrowRightIcon } from "vue-tabler-icons";
import ListFontsModal from "./style/ListFontsModal.vue";
import { useQrCreateStore } from "~~/stores/qrcreate";
import InputStyle from "../form/InputStyle.vue";
import SwitchStyle from "../form/SwitchStyle.vue";
import _ from "lodash";
import { storeToRefs } from "pinia";

export default defineComponent({
    setup() {
        const qrcreate = useQrCreateStore()
        const qrstyle = useQrStyle()
        const { fields } = storeToRefs(qrcreate)
        watchDebounced(fields, (v) => {
            qrstyle.GenerateQrCode({})
        }, { deep: true, debounce: 300, maxWait: 5000 })
        return {
            qrcreate, qrstyle, font_selected: ref({})
        }
    },
    components: {
        ChevronDownIcon,
        LetterAIcon,
        SeparatorIcon,
        ListFontsModal,
        SwitchStyle,
        InputStyle,
        ArrowRightIcon
    },
    computed: {
        keys_fields() {
            return Object.keys(this.qrcreate.fields);
        },
    },
    methods: {
        selectFont(param, key_name, font_family) {
            this.font_selected = { param, key_name, name: font_family, weight: 400 };
            this.$refs.modal.openModal();
        },
        changeFont(font) {
            this.font_selected = _.merge(this.font_selected, font);
            this.qrcreate.fields[this.font_selected.param][
                this.font_selected.key_name
            ].font_family = font.name;
        },
        SwitchTab(){
            this.qrcreate.tab_active = 'Public Style'
        }

    },

});
</script>
  